export default __webpack_public_path__ + "static/media/csc_03.51a50258.png";